export class ContactValidator {
  static validate(contactData: any, t: any): string[] {
    const validationErrors: string[] = [];

    if (!contactData.firstName?.trim()) {
      validationErrors.push(t("contact:form.fields.firstname.label"));
    }

    if (!contactData.lastName?.trim()) {
      validationErrors.push(t("contact:form.fields.lastname.label"));
    }

    if (!contactData.function?.trim()) {
      validationErrors.push(t("contact:form.fields.function.label"));
    }

    if (!contactData.civility) {
      validationErrors.push(t("contact:form.fields.civility.label"));
    }

    if (!contactData.contactInfo?.email?.trim() && (!contactData.contactInfo?.emails || !Array.isArray(contactData.contactInfo.emails) || contactData.contactInfo.emails.length === 0)) {
      validationErrors.push(t("common:contactInfo") + " - " + t("common:email"));
    }

    if (!contactData.contactInfo?.phone?.trim()) {
      validationErrors.push(t("common:contactInfo") + " - " + t("common:phone"));
    }

    return validationErrors;
  }
}
